import { docPath } from './franklyNetHost';
import React from 'react';

const formatDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
};

function DocArticle({ article, related }) {
    const published = formatDate(article.publishedAt);

    return (
        <>
            <div className="mb-3 flex flex-wrap items-center gap-2 border border-gray-300 bg-offwhite px-3 py-2">
                <span className="font-['Jersey_10'] text-[16px] uppercase tracking-[1px] text-maroon">
                    Habbo Origins News
                </span>
                {article.categoryLabel && (
                    <span className="text-[12px] text-gray-500">{article.categoryLabel}</span>
                )}
                {article.habboUrl && (
                    <a
                        href={article.habboUrl}
                        target="_blank"
                        rel="noreferrer noopener external"
                        className="ml-auto border border-gray-300 bg-white px-3 py-1 text-[12px] uppercase text-maroon hover:bg-gray-100"
                    >
                        Read it on Origins
                    </a>
                )}
            </div>

            <article className="border border-gray-300 bg-white">
                {article.heroImageUrl && (
                    <div className="w-full overflow-hidden border-b border-gray-200 bg-gray-100">
                        <img src={article.heroImageUrl} alt="" aria-hidden="true" className="block h-auto w-full" />
                    </div>
                )}

                <div className="p-5 sm:p-7">
                    <h1 className="font-['Jersey_10'] text-[30px] uppercase leading-tight tracking-[1px] text-maroon">
                        {article.title}
                    </h1>

                    <div className="mt-1 flex flex-wrap items-center gap-2 text-[12px] text-gray-500">
                        {published && <span>{published}</span>}
                        {article.categoryLabel && <><span>|</span><span>{article.categoryLabel}</span></>}
                        <span>|</span>
                        <span>Archived by Frank so it opens in here</span>
                    </div>

                    {article.summary && (
                        <p className="mt-4 border-l-4 border-gold bg-offwhite p-3 text-[15px] italic leading-relaxed text-gray-700">
                            {article.summary}
                        </p>
                    )}

                    <div
                        className="askfrank-article mt-5 text-[15px] leading-relaxed text-gray-800"
                        dangerouslySetInnerHTML={{ __html: article.bodyHtml }}
                    />
                </div>
            </article>

            {related.length > 0 && (
                <div className="mt-5 border border-gray-300 bg-offwhite p-4">
                    <p className="mb-3 font-['Jersey_10'] text-[16px] uppercase tracking-[1px] text-gray-700">
                        More from Habbo Origins
                    </p>
                    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                        {related.map(item => (
                            <a
                                key={item.slug}
                                href={docPath('article', item.slug)}
                                className="flex items-center gap-2 border border-gray-300 bg-white p-2 hover:bg-gray-50"
                            >
                                {item.heroImageUrl && (
                                    <img
                                        src={item.heroImageUrl}
                                        alt=""
                                        aria-hidden="true"
                                        className="h-[40px] w-[64px] shrink-0 object-cover"
                                    />
                                )}
                                <span className="min-w-0 flex-1 truncate text-[13px] text-maroon">{item.title}</span>
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}

export default DocArticle;
